import React, { useState } from "react";
import TableHeader from "../Assets/TableHeader";
import TableBody from "../Assets/TableBody";
import { DosageEntry } from "../Types/Types";
import LoadingCircle from "../Assets/LoadingCirlce";
import TableFooterPagination from "../Assets/TableFooterPagination"; // Pagination footer component

interface AdminDosageTableProps {
  dosageData: DosageEntry[];
  loading: boolean;
  error: string | null;
  onDelete: (id: string) => void;
  onEdit: (entry: DosageEntry) => void;
  onSortChange: (field: string, order: string) => void;
  lang: string;
}

const AdminDosageTable: React.FC<AdminDosageTableProps> = ({
  dosageData,
  loading,
  error,
  onDelete,
  onEdit,
  onSortChange,
  lang,
  
}) => {
  const [sortBy, setSortBy] = useState<string>("createdAt");
  const [sortOrder, setSortOrder] = useState<string>("desc");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);

  const totalPages = Math.ceil(dosageData.length / rowsPerPage);
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentData = dosageData.slice(indexOfFirst, indexOfLast);

  const handleSort = (column: string) => {
    const newOrder = sortBy === column && sortOrder === "asc" ? "desc" : "asc";
    setSortBy(column);
    setSortOrder(newOrder);
    onSortChange(column, newOrder);
  };

  const handlePageChange = (newPage: number) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleRowsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newRows = parseInt(e.target.value, 10);
    setRowsPerPage(newRows);
    setCurrentPage(1);
  };

  if (loading) return <LoadingCircle />;
  if (error) return <div className="text-center py-4 text-red-500">{error}</div>;

  return (
    <div className="overflow-x-auto bg-white shadow-md rounded-lg">
      <table className="min-w-full table-auto">
        <TableHeader
          data={dosageData}
          handleSort={handleSort}
          sortBy={sortBy}
          sortOrder={sortOrder}
        />
        <TableBody
          data={currentData}
          onDelete={onDelete}
          onEdit={onEdit}
          lang={lang}
          editable={false}
        />
      </table>
      <TableFooterPagination
        currentPage={currentPage}
        totalPages={totalPages}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </div>
  );
};

export default AdminDosageTable;
